/**
 * Map a 0–100 progress value to a color hex.
 *
 * Each consumer in the codebase uses a slightly different palette for its
 * progress bars; rather than unify them (which would change visible UX),
 * the `scheme` parameter selects the exact palette the consumer was using
 * before the migration. Adding a new consumer? Pick the scheme that
 * matches the visual you want — or add a new one with a clear name.
 *
 * @param {number|null|undefined} value - progress 0..100
 * @param {object} [opts]
 * @param {'analysis'|'completeness'} [opts.scheme='analysis'] - palette name
 * @param {boolean} [opts.complete=false] - 'analysis' scheme: short-circuit to green when true
 * @returns {string} hex color
 */
export function getProgressColor(value, { scheme = 'analysis', complete = false } = {}) {
  if (scheme === 'completeness') {
    return value === 100 ? '#10b981' : '#f97316';
  }

  // 'analysis' (default)
  if (complete) return '#10B981';
  if (value < 25) return '#F59E0B';
  if (value < 50) return '#EF4444';
  if (value < 75) return '#DC2626';
  return '#10B981';
}
